import styled from 'styled-components';
import {flexUnit} from '../../global-styles/mixins.js';
const StyledNewsArticle = styled.div`
  background-color: ${props => props.bgColor};
  padding-top: ${props => props.theme.components_spacing_desk.xxlarge}px;
  padding-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px;
  padding-right: 64px;
  padding-left: 64px;
  .article-header{
    position: relative;
    width: 66.66%;
  }
  .category {
    text-transform: uppercase;
    color: ${props => props.theme.colors.green_secondary};
    padding: 14px 0;
    margin-bottom: 24px;
  }
  .news-title {
    margin-bottom: 24px;
  }
  .details-wrapper {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #4D4D4D;
  }
  .detail-col{
    display: flex;
    align-items: center;
    margin-right: 24px;
  }
  .detail-col img {
    margin-right: 8px;
  }
  .cover-image{
    display: block;
    width: 100%;
    margin: ${props => props.theme.components_spacing_desk.xlarge}px auto;
  }
  .article-wrap{
    position: relative;
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
  article.text-wrap {
    flex: 0 0 66.66%;
    max-width: 66.66%;
  }
  article h2 {
    ${flexUnit(5, 35, 54, 'vw', 'font-size')};
    line-height: 110%;
    letter-spacing: -.05em;
    font-family: 'Alliance No.2', sans-serif;
    font-weight: 400;
    margin-bottom: 40px;
  }
  article h3 {
    font-size: 35px;
    line-height: 130%;
    font-weight: 400;
    color: #000;
    margin-bottom: 40px;
  }
  article h5 {
    font-size: 18px;
    line-height: 130%;
    font-weight: 400;
  }
  article h5 a {
    color: ${props => props.theme.colors.green_secondary};
  }
  article h5 a:after {
    content: '';
    position: relative;
    background-image: url("/arrow-up-right.svg");
    width: 16px;
    height: 16px;
    margin-left: 8px;
  }
  article p,
  article ul,
  article ol{
    font-size: 28.13px;
    line-height: 130%;
    font-family: aktiv-grotesk, sans-serif;
    font-weight: 400;
    color: #4D4D4D;
    margin-bottom: 40px;
  }
  article ul li,
  article ol li {
    font-size: 28.13px;
    line-height: 130%;
    font-family: aktiv-grotesk, sans-serif;
    font-weight: 400;
    color: #4D4D4D;
  }
  article ul li,
  article ol li {
    margin-bottom: 24px;
  }
  article ol,
  article ul {
    counter-reset: item;
    list-style-type: none;
  }
  article ol li,
  article ul li { 
    position: relative;
    padding-left: 25px; 
    align-items: center;
  }
  article ol li:before { 
    content: counter(item) "  "; 
    counter-increment: item;
    color: #B3B3B3;
    margin-right: 8px;
  }
  article ul li:before { 
    content: ""; 
    position: absolute;
    border-radius: 50%;
    width: 8px;
    height: 8px;
    background-color: #B3B3B3;
    margin-right: 12px;
    left: 0;
    top: 12px;
  }
  article p b{
    color: #000;
    font-weight: bold;
  }
  article p a{
    color: ${props => props.theme.colors.green_secondary};
  }
  article p strong {
    font-weight: bold;
    color: #000;
  }
  article p a strong {
    font-weight: 400;
    color: ${props => props.theme.colors.green_secondary};
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  article p a strong:after {
    content: '';
    position: relative;
    background-image: url("/arrow-up-right.svg");
    width: 16px;
    height: 16px;
    margin-left: 8px;
  }
  article iframe {
    width: 100%;
  }
  article img, article figure {
    display: block;
    width: 100% !important;
    height: auto;
    align-self: center;
  }
  .aside-article{
    flex: 0 0 25%;
  }
  .aside-cell{
    margin-bottom: 40px;
  }
  .aside-cell p,
  .aside-cell img{
    margin-bottom: 8px
  }
  .speaker {
    color: #666666;
  }
  .place-cell a {
    color: ${props => props.theme.colors.green_secondary};
    display: flex;
  }
  .place-cell a:after {
    content: '';
    position: relative;
    background-image: url("/maps-icon.svg");
    width: 16px;
    height: 16px;
    background-size: 16px;
    margin-left: 8px;
    display: inline-block
  }
  @media screen and (max-width: 1439px){
    padding-right: 40px;
    padding-left: 40px
  }
  @media screen and (max-width: 1023px){
    padding-top: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    padding-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    .article-header{
      width: 100%;
    }
    .cover-image {
      margin: ${props => props.theme.components_spacing_tablet.xlarge}px auto;
    }
    article h3 {
      font-size: 28px;
    }
    article h5 {
      font-size: 16px;
      font-weight: 400;
    }
    article p,
    article ul li,
    article ol li {
      font-size: 22.5px;
    }
  }
  @media screen and (max-width: 767px){
    padding-right: 24px;
    padding-left: 24px;
    padding-top: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    padding-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    .cover-image {
      margin: ${props => props.theme.components_spacing_mobile.xlarge}px auto;
    }
    .detail-col {
      flex-direction: column;
    }
    article.text-wrap {
      flex: 0 0 100%;
      max-width: 100%;
    }
    article h2 {
      margin-bottom: 32px;
    }
    article h3 {
      font-size: 22.5px;
      margin-bottom: 32px;
    }
    article h5 {
      font-size: 14px
    }
    article p,
    article ul li,
    article ol li {
      font-size: 18px;
    }
    article p,
    article ul,
    article ol {
      margin-bottom: 32px;
    }
    article ul li,
    article ol li {
      margin-bottom: 16px;
    }
  }
`;

export {
  StyledNewsArticle,
};

